import React, { useState } from "react";
import "../../Styles/CreateUser.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../../Components/Loader";

function CreateUser() {
    const [userDetails, setUserDetails] = useState({
        userType: "",
        name: "",
        email: "",
        password: "",
        employeeCode: "",
        organizationName: "",
        organizationAddress: "",
        organizationContact: "",
        gender: "", 
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserDetails((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('authToken');

        if (!token) {
            toast.error("You need to be logged in to create a user.");
            return;
        }

        setLoading(true);

        try {
            const response = await fetch('https://api.uniums.com/api/auth/create-user', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(userDetails),
            });

            const data = await response.json();
            setLoading(false);

            if (response.ok) {
                toast.success(data.message);
                setUserDetails({
                    userType: "",
                    name: "",
                    email: "",
                    password: "",
                    employeeCode: "",
                    organizationName: "",
                    organizationAddress: "",
                    organizationContact: "",
                    gender: "",
                });
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            setLoading(false);
            toast.error("An error occurred, please try again!");
        }
    };

    return (
        <div className="create-user-container">
            <h1>Create User</h1>
            {loading && <Loader />}
            <form className="create-user-form" onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="userType">User Type <span>*</span></label>
                        <select
                            id="userType"
                            name="userType"
                            value={userDetails.userType}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select User Type</option>
                            <option value="faculty">Faculty</option>
                            <option value="student">Student</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="name">Name <span>*</span></label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={userDetails.name}
                            onChange={handleChange}
                            placeholder="Enter name"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="gender">Gender <span>*</span></label>
                        <select
                            id="gender"
                            name="gender"
                            value={userDetails.gender}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                            <option value="other">Other</option>
                            <option value="prefer_not_to_say">Prefer not to say</option>
                        </select>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="email">Email <span>*</span></label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={userDetails.email}
                            onChange={handleChange}
                            placeholder="Enter email"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password <span>*</span></label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={userDetails.password}
                            onChange={handleChange}
                            placeholder="Enter password"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="employeeCode">Employee Code <span>*</span></label>
                        <input
                            type="text"
                            id="employeeCode"
                            name="employeeCode"
                            value={userDetails.employeeCode}
                            onChange={handleChange}
                            placeholder="Enter employee code"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="organizationName">Organization Name <span>*</span></label>
                        <input
                            type="text"
                            id="organizationName"
                            name="organizationName"
                            value={userDetails.organizationName}
                            onChange={handleChange}
                            placeholder="Enter organization name"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="organizationAddress">User Address <span>*</span></label>
                        <input
                            type="text"
                            id="organizationAddress"
                            name="organizationAddress"
                            value={userDetails.organizationAddress}
                            onChange={handleChange}
                            placeholder="Enter User address"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="organizationContact">User Contact <span>*</span></label>
                        <input
                            type="text"
                            id="organizationContact"
                            name="organizationContact"
                            value={userDetails.organizationContact}
                            onChange={handleChange}
                            placeholder="Enter User contact"
                            required
                        />
                    </div>
                </div>

                <button type="submit" className="submit-button" disabled={loading}>
                    {loading ? "Submitting..." : "Create User"}
                </button>
            </form>
            <ToastContainer />
        </div>
    );
}

export default CreateUser;